export default {
  featuredExperiences: 'Nos meilleures expériences',
  searchAllExperiences: 'Voir toutes les expériences',
  searchAll: 'Voir toutes ',
  groupSize: 'Capacité',
  eventSize: 'Nombre de participants',
  upTo: 'Jusqu’à',
  whatWeDo: 'Au programme',
  hostedBy: 'Proposée par',
  whatsIncluded: 'Ce qui est inclus',
  avail: 'Disponibilité',
  whereWeAre: 'Le lieu',
  experienceCalendar: 'Calendrier des expériences',
  experienceCancelled: 'Expérience annulée',
  experienceStartingPrice: 'À partir de {{price}}',
  experienceTotalPrice: 'Total {{price}}',
  at: 'à',
  viewPrivateSessAvailability: 'Voir la disponibilité des expériences privées',
  selectSession: 'Sélectionner l’horaire',
  sessionsCount: '{{count}} horaires — choisissez une heure',
  select: 'Sélectionner',
  slotLeft: '{{remainSlots}} place restante',
  slotsLeft: '{{remainSlots}} places restantes',
  spotsLeft: '{{count}} restant(e)s',
  spotsLeftAriaLabel: '{{count}} places restantes',
  bookExperience: 'Réserver l’expérience',
  book: 'Réserver',
  learnMore: 'En savoir plus',
  apply: 'Valider',
  maxPartySizes: 'Maximum {{maxGroupSize}} participants par groupe',
  maxPartySize: 'Maximum {{maxGroupSize}} participant par groupe',
  selectSessionValidation: 'Veuillez sélectionner l’horaire',
  selectParticipantValidation:
    'Veuillez sélectionner le nombre de participants',
  selectDateValidation: '',
  reminders: 'Rappels',
  seeOtherDates: 'Voir les autres dates',
  location: 'Point de rendez-vous',
  about: 'À propos',
  allExperiences: 'Toutes les expériences',
  soldOut: 'Complète',
  reviews: 'Les Commentaires',
  reviewSingular: 'commentaire',
  reviewPlural: 'commentaires',
  dateOfExperience: 'la date de l’expérience',
  readLess: 'Afficher moins',
  readMore: 'Afficher plus',
  seeMore: 'Voir les détails',
  details: 'Détails',
  durationHour: 'heure',
  durationHours: 'heures',
  durationMinutes: 'min',
  theFollowingVideoDoesNotContainAnyAudio: 'Cette vidéo ne contient pas de son',
  by: 'Par',
  chooseATime: 'Choisissez une heure pour {{title}}',
  amenities: 'Amenités',
  ticketSalesOpenIn: 'Ouverture des ventes dans',
  ticketSalesOpen: 'Vente de billets ouverte',
  ticketSalesCloseIn: 'Fermeture des ventes dans',
  ticketSalesClose: 'Vente de billets fermée',
  ticketSalesClosed: 'Vente de billets terminée',
  comingSoon: 'Bientôt disponible',
  inPartnershipWith: 'En partenariat avec',
  notFoundExperienceTitle: "Cette expérience n'est plus disponible",
  notFoundExperienceSubtitle:
    "Elle a peut-être été dépubliée ou le lien n'est plus valide.",
  deadLinkRecoverySubtitle:
    'Découvrez d’autres expériences disponibles à la réservation',
  viewAllExperiences: 'Voir toutes les expériences',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>Gagnez 5 Points de base</strong> par dollar USD éligible dépensé en vous connectant à votre compte World of Hyatt pour réserver cette expérience</p>',
      basePoints:
        '<p><strong>Gagnez 10 Points de base</strong> par dollar USD éligible dépensé en vous connectant à votre compte World of Hyatt pour réserver cette expérience</p>',
      additionalBonusPoints:
        '<p><strong>Gagnez 4 Points bonus de plus</strong> par dollar USD éligible dépensé en réservant avec votre carte de crédit World of Hyatt</p>',
      additionalBonusPointsTier:
        "<p><strong>Gagnez jusqu'à 30 % de Points bonus supplémentaires</strong> en fonction de votre niveau d'adhésion</p>",
      payWithPoints:
        '<p><strong>Payez avec des points</strong> lors de la réservation de cette expérience</p>',
    },
  },
};
